export const typography = {
    fontFamily: ["Mont", "sans-serif"].join(","),
    h1: {
      fontWeight: 800,
      fontSize: "48px",
      lineHeight: "56px",
    },
    h1Mob: {
      fontWeight: 800,
      fontSize: "32px",
      lineHeight: "41px",
    },
    h2: {
      fontWeight: 800,
      fontSize: "32px",
      lineHeight: "41px",
    },
    h2Mob: {
      fontWeight: 800,
      fontSize: "22px",
      lineHeight: "31px",
    },
    h3: {
      fontWeight: 800,
      fontSize: "22px",
      lineHeight: "30px",
    },
    h3Mob: {
      fontWeight: 700,
      fontSize: "20px",
      lineHeight: "26px",
    },
    h4: {
      fontWeight: 700,
      fontSize: "20px",
      lineHeight: "26px",
    },
    h4Mob: {
      fontWeight: 700,
      fontSize: "16px",
      lineHeight: "20px",
    },
    button: {
      fontWeight: 600,
      fontSize: "14px",
      lineHeight: "21px",
      textTransform: "uppercase" as const,
      textDecoration: 'none',
    },
    body1: {
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "21px",
    },
    body2: {
      fontWeight: 600,
      fontSize: "12px",
      lineHeight: "16px",
    },
    upper: {
      fontWeight: 700,
      fontSize: "12px",
      lineHeight: "11px",
      textTransform: "uppercase" as const,
    },
    link: {
      fontSize: '12px',
      fontWeight: '800',
      lineHeight: '11px',
      letterSpacing: '0.04em',
      textTransform: "uppercase" as const,
    },
}